import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { ChannelView } from '../components/channels/ChannelView';

export const MessagesPage = ({ selectedChannel, onSelectChannel }) => {
  const { user, token } = useAuth();

  return (
    <div className="h-screen flex bg-[#1a1d21]" data-testid="messages-page">
      {/* Main Channel View - now takes full width since sidebar is in AppLayout */}
      <ChannelView
        channel={selectedChannel}
        token={token}
        currentUser={user}
      />
    </div>
  );
};

export default MessagesPage;
